import { Chart } from "chart.js/auto";
import { useRef, useEffect, useState } from "react";

function GraficoParticipacion({ onImageReady }) {
  const canvasRef = useRef(null);
  const [statistics, setStatistics] =  useState(null); // 👈 null al inicio
  const [message, setMessage] = useState("");

  // 1. Obtener datos desde backend
  useEffect(() => {
    const token = localStorage.getItem("token");

    fetch("https://api.grekad.cfcunap.cl/api/statistics", {
      method: "GET",
      headers: { Authorization: token },
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.success) {
          setStatistics(data.statistics); // 👈 guardamos datos
        } else {
          setMessage(data.message || "Error al obtener estadísticas.");
        }
      })
      .catch(() => {
        setMessage("Error en la conexión al servidor.");
      });
  }, []);

  // 2. Dibujar gráfico cuando haya datos
  useEffect(() => {
    if (!statistics) return; 

    const ctx = canvasRef.current.getContext("2d");

    const votantes = statistics[0].porcentaje_participacion || 0;
    const participantes = statistics[0].total_personas_participantes || 0;
    const noVotantes = statistics[0].porcentaje_no_participacion || 0;

    console.log("Generando gráfico con:", { statistics,votantes, noVotantes, participantes });

    const chart = new Chart(ctx, {
      type: "bar",
      data: {
        labels: ["Votaron", "No Votaron"],
        datasets: [
          {
            label: 'Porcentaje de Participación - Trabajador destacado 2025',
            data: [votantes, noVotantes],
            backgroundColor: ['rgba(255, 99, 132, 0.2)',
                              'rgba(54, 162, 235, 0.2)'],
             borderColor:    ['rgb(255, 99, 132)',
                              'rgb(54, 162, 235)'],
             borderWidth: 1
          },
        ],
      },
      options: {  animation: false, 
                  devicePixelRatio: 2,
                  scales: {
      y: {
        beginAtZero: true
      }
    } 
    },
    }
  );

    // esperar a que se pinte y exportar como imagen base64
    setTimeout(() => {
      const imgBase64 = chart.toBase64Image("image/png", 1.0);
      console.log("Gráfico generado base64:", imgBase64.substring(0, 50) + "...");
      onImageReady(imgBase64);
    }, 300);

    return () => chart.destroy();
  }, [statistics, onImageReady]); // 👈 depende de statistics

  return (
    <div>
      {message && <p style={{ color: "red" }}>{message}</p>}
      <canvas
        ref={canvasRef}
        width={400}
        height={400}
        //style={{ visibility: "hidden", position: "absolute" }} // 👈 oculto pero renderiza
      />
    </div>
  );
}

export default GraficoParticipacion;
